import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { LanguageSelector } from './LanguageSelector';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { user, member, family, logout } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();

  const navLinks = [
    { path: '/dashboard', label: t('todaysAffirmation').split(' ')[0], icon: '🌟' },
    { path: '/family', label: t('myFamily').split(' ').pop(), icon: '👨‍👩‍👧‍👦' },
    { path: '/recordings', label: t('myRecordings').split(' ').pop(), icon: '🎙️' },
    { path: '/research', label: t('research'), icon: '📚' },
  ];

  const displayName = user?.name || member?.name;

  return (
    <div className="min-h-screen">
      <nav className="nav">
        <div className="nav-inner">
          <Link to="/dashboard" className="nav-brand">
            ✨ MindsetFamily
          </Link>

          <ul className="nav-links">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                >
                  <span>{link.icon}</span>
                  <span>{link.label}</span>
                </Link>
              </li>
            ))}
          </ul>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <LanguageSelector />
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold">{displayName}</p>
              <p className="text-xs text-gray-500">{family?.name}</p>
            </div>
            <button
              onClick={logout}
              className="btn btn-secondary"
              style={{ padding: '0.5rem 1rem', fontSize: '0.875rem' }}
            >
              {t('logout')}
            </button>
          </div>
        </div>
      </nav>

      <main>{children}</main>

      <footer style={{ textAlign: 'center', padding: '3rem 1rem', marginTop: '2rem', color: 'var(--gray-500)', fontSize: '0.875rem' }}>
        <p>MindsetFamily - {t('footerTagline')} 💜</p>
      </footer>
    </div>
  );
}
